module.exports = __webpack_public_path__ + "static/6_poprawki2_papa-9f174d352e2e800a350cb6b2448cde7c.jpg";